<template>
  <div class="news-page ctn">
    <h1>新闻资讯</h1>
    <button type="button" class="prev" :class="prevClass" @click="goPrev"/>
    <button type="button" class="next" :class="nextClass" @click="goNext"/>
    <a v-if="query !== ''" class="back" href="#/News">查看更多</a>
    <ul>
      <li v-for="(item, index) in filterData" :key="index">
        <a :href="'#/NewsDetail/' + item.id"><img :src="item.thumb"/></a>
        <time>{{ item.created_date }}</time>
        <span v-for="(tag, key) in item.tags" :key="key" @click="go(tag)">{{ tag }}</span>
        <h3><a :href="'#/NewsDetail/' + item.id">{{ item.title }}</a></h3>
        <p>{{ item.summary }}</p>
      </li>
    </ul>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'App',
  components: {

  },
  data() {
    return {
      oriNews: [],
      curPage: 1,
      query: ''
    }
  },
  computed: {
    prevClass() {
      return this.curPage <= 1 ? 'disabled' : ''
    },
    nextClass() {
      return this.endIndex >= this.news.length ? 'disabled' : ''
    },
    news() {
      let news = []
      if (this.query !== '') {
        news = this.oriNews.filter(o => o.tags.indexOf(this.query) >= 0)
      } else {
        news = this.oriNews
      }
      return news
    },
    filterData() {
      return this.news.length > 0 ? this.news.slice((this.curPage - 1) * 3, this.endIndex) : []
    },
    endIndex() {
      const end = this.curPage * 3
      return end > this.news.length ? this.news.length : end
    }
  },
  watch: {
    $route: {
      handler() {
        const q =  this.$route.params.q
        if (typeof q !== 'undefined') {
          this.query = q
        } else {
          this.query = ''
        }
      },
      deep: true
    }
  },
  created() {
    const q =  this.$route.params.q
    if (q) this.query = q
    this.getData()
  },
  methods: {
    getData() {
      axios.get('/api/v1/article/list?home_recommend=1').then(r => {
        if (r && r.data && r.data.list)
        this.oriNews = r.data.list
      })
    },
    goPrev() {
      this.curPage > 1 && this.curPage--
    },
    goNext() {
      this.endIndex < this.news.length && this.curPage++
    },
    go(tag) {
      location.href='#/NewsCata/' + tag.replaceAll('#','').trim()
    }
  }
}
</script>
